export enum ExecuteRothConversionActionTypes {
  EXECUTE_ROTH_CONFIRMATION = 'EXECUTE_ROTH_CONFIRMATION',
  EXECUTE_ROTH_CONVERSION = 'EXECUTE_ROTH_CONVERSION',
  EXECUTE_ROTH_CONVERSION_PENDING = 'EXECUTE_ROTH_CONVERSION_PENDING',
  EXECUTE_ROTH_CONVERSION_FULFILLED = 'EXECUTE_ROTH_CONVERSION_FULFILLED',
  EXECUTE_ROTH_CONVERSION_REJECTED = 'EXECUTE_ROTH_CONVERSION_REJECTED',
  ROTH_CONVERSION_TRADE_DATES = 'ROTH_CONVERSION_TRADE_DATES',
}
